import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Form from '../../Form';

import Loading from '../../Loading';

class AccountStaffChangePasswordForm extends Form {
    static propTypes = {
        onUserUpdateRequest: PropTypes.func,
        onUserUpdateClear: PropTypes.func,

        user: ImmutablePropTypes.map,
        status: ImmutablePropTypes.string
    };

    static fieldsValidation = {
        oldPassword: ['required', [ 'minLength' , 6]],
        newPassword1: ['required', [ 'minLength' , 8]],
        newPassword2: ['required', [ 'minLength' , 8]]
    };

    static defaultProps = {
        user: Map(),
    };

    UNSAFE_componentWillMount() {
        this.props.onUserUpdateClear();
    }

    compareNewPasswords() {
        const { newPassword2, newPassword1 } = this.state.data;

        if (newPassword1 !== newPassword2) {
            this.state.invalid['newPassword2'] = true;
            this.state.errors['newPassword2'] = 'Confirm Password should match New Password';

            this.setState({...this.state});

            return false;
        }

        return true;
    }

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);

        const isValid = Object.keys(this.state.errors).filter( x => typeof this.state.errors[x] === 'string').length === 0;
        if (isValid) {
            const valid = this.compareNewPasswords();

            if (valid) {
                const {oldPassword, newPassword1} = this.state.data;
                this.props.onUserUpdateRequest(oldPassword, newPassword1);
            }
        }
    }

    renderForm() {
        const {status} = this.props;
        const isValid = Object.keys(this.state.errors).filter( x => typeof this.state.errors[x] === 'string').length === 0;

        return (
            <div className='admin-users chnage-password'>
                <div className='row'>
                    <div className='col-4'>
                        <h4 className='chanage-password'>Change password for user { this.props.user.get('name') } </h4>

                        {
                            this.getField(
                                <input type='password'
                                    label='Old Password'
                                    { ...this.getFieldParameters('oldPassword') }
                                />
                            )
                        }
                        {
                            this.getField(
                                <input type='password'
                                    label='New Password'
                                    { ...this.getFieldParameters('newPassword1') }
                                />
                            )
                        }
                        {
                            this.getField(
                                <input type='password'
                                    label='Confirm Password'
                                    { ...this.getFieldParameters('newPassword2') }
                                />
                            )
                        }
                    </div>
                </div>

                { status === 'FINISHED' && isValid ? <medium>Password changed successfully.</medium> : null}


                <div className='buttons'>
                    <button className='btn btn-primary' type='submit'>
                        Change Password
                    </button>
                </div>

                <Loading active={ this.props.status === 'IN_PROGRESS' } />
            </div>
        );
    }
}

export default AccountStaffChangePasswordForm;
